import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Tabs from "../../../../Components/Tabs";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Pagination from "../../../../Core/Pagination/Pagination";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from "../../../../Core/Export/ExportCSV";
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import useScreenHeight from "../../../../utils/useScreenHeight";

const qualityReviewSeedData = [
  {
    id: "QR-0001",
    serialNo: "QR-2025-0001",
    company: "M&T Glass Works",
    reviewType: "Incoming",
    reviewer: "Mark Jensen",
    reportDate: "2025-07-03",
    dateTime: "2025-07-03T10:05:00",
    status: "Draft",
  },
  {
    id: "QR-0002",
    serialNo: "QR-2025-0002",
    company: "M&T Glass Works",
    reviewType: "Outgoing",
    reviewer: "Mila Patel",
    reportDate: "2025-07-03",
    dateTime: "2025-07-03T10:06:45",
    status: "Submitted",
  },
  {
    id: "QR-0003",
    serialNo: "QR-2025-0003",
    company: "M&T Glass Works",
    reviewType: "Incoming",
    reviewer: "Mila Patel",
    reportDate: "2025-07-03",
    dateTime: "2025-07-03T10:08:10",
    status: "Submitted",
  },
  {
    id: "QR-0004",
    serialNo: "QR-2025-0004",
    company: "M&T Glass Works",
    reviewType: "Outgoing",
    reviewer: "Mark Jensen",
    reportDate: "2025-07-03",
    dateTime: "2025-07-03T10:09:30",
    status: "Draft",
  },
  {
    id: "QR-0005",
    serialNo: "QR-2025-0005",
    company: "M&T Glass Works",
    reviewType: "In Process",
    reviewer: "Nina Bose",
    reportDate: "2025-07-03",
    dateTime: "2025-07-03T10:10:55",
    status: "Submitted",
  },
  {
    id: "QR-0006",
    serialNo: "QR-2025-0006",
    company: "M&T Glass Works",
    reviewType: "In Process",
    reviewer: "Nina Bose",
    reportDate: "2025-07-03",
    dateTime: "2025-07-03T10:12:18",
    status: "Draft",
  },
  {
    id: "QR-0007",
    serialNo: "QR-2025-0007",
    company: "M&T Glass Works",
    reviewType: "Incoming",
    reviewer: "Samuel Reed",
    reportDate: "2025-07-03",
    dateTime: "2025-07-03T10:13:20",
    status: "Draft",
  },
  {
    id: "QR-0008",
    serialNo: "QR-2025-0008",
    company: "M&T Glass Works",
    reviewType: "Incoming",
    reviewer: "Samuel Reed",
    reportDate: "2025-07-03",
    dateTime: "2025-07-03T10:14:33",
    status: "Cancelled",
  },
  {
    id: "QR-0009",
    serialNo: "QR-2025-0009",
    company: "M&T Glass Works",
    reviewType: "Outgoing",
    reviewer: "Mila Patel",
    reportDate: "2025-07-03",
    dateTime: "2025-07-03T10:15:44",
    status: "Submitted",
  },
  {
    id: "QR-0010",
    serialNo: "QR-2025-0010",
    company: "M&T Glass Works",
    reviewType: "In Process",
    reviewer: "Mark Jensen",
    reportDate: "2025-07-03",
    dateTime: "2025-07-03T10:17:10",
    status: "Cancelled",
  },
  {
    id: "QR-0011",
    serialNo: "QR-2025-0011",
    company: "M&T Glass Works",
    reviewType: "Incoming",
    reviewer: "Samuel Reed",
    reportDate: "2025-07-03",
    dateTime: "2025-07-03T10:18:25",
    status: "Draft",
  },
  {
    id: "QR-0012",
    serialNo: "QR-2025-0012",
    company: "M&T Glass Works",
    reviewType: "Incoming",
    reviewer: "Nina Bose",
    reportDate: "2025-07-03",
    dateTime: "2025-07-03T10:19:55",
    status: "Cancelled",
  },
];

const statusColors = {
  draft: "#6366F1",
  submitted: "#0E7490",
  cancelled: "#EF4444",
};

const MainList = () => {
  const navigate = useNavigate();
  const { pageSize } = useScreenHeight();
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});
  const [showFilters, setShowFilters] = useState(false);
  const [showColumns, setShowColumns] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [qualityReviews] = useState(qualityReviewSeedData);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [columnsConfig, setColumnsConfig] = useState([
    {
      header: "S.No.",
      accessor: "siNo",
      name: "siNo",
      width: "6%",
      sortable: false,
      visible: true,
      cellRenderer: (row) => row.siNo,
    },
    {
      header: "Serial No.",
      accessor: "serialNo",
      name: "Serial No.",
      width: "15%",
      sortable: true,
      visible: true,
    },
    {
      header: "Company",
      accessor: "company",
      name: "Company",
      width: "15%",
      sortable: true,
      visible: true,
    },
    {
      header: "Review Type",
      accessor: "reviewType",
      name: "Review Type",
      width: "12%",
      sortable: true,
      visible: true,
    },
    {
      header: "Reviewer",
      accessor: "reviewer",
      name: "Reviewer",
      width: "12%",
      sortable: true,
      visible: true,
    },
    {
      header: "Report Date",
      accessor: "reportDate",
      name: "Report Date",
      width: "12%",
      sortable: true,
      visible: true,
      cellRenderer: (row) =>
        new Date(row.reportDate).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),
    },
    {
      header: "Date & Time",
      accessor: "dateTime",
      name: "Date & Time",
      width: "15%",
      sortable: true,
      visible: true,
      cellRenderer: (row) =>
        new Date(row.dateTime).toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }),
    },
    {
      header: "Status",
      accessor: "status",
      name: "Status",
      width: "12%",
      sortable: true,
      visible: true,
      cellRenderer: (row) => {
        const color = statusColors[row.status?.toLowerCase()] || "#4B5563";
        return (
          <span
            style={{
              backgroundColor: `${color}1A`,
              color,
              padding: "4px 12px",
              borderRadius: 999,
              fontSize: "12px",
              fontWeight: 500,
              textTransform: "capitalize",
            }}
          >
            {row.status?.toLowerCase()}
          </span>
        );
      },
    },
    {
      header: "Actions",
      accessor: "action",
      name: "Actions",
      width: "8%",
      sortable: false,
      visible: true,
      cellRenderer: (row) => (
        <ActionButtonDropdown
          id={row.id}
          onView={() => handleView(row.id)}
          onEdit={() => handleEdit(row.id)}
          onDelete={() => handleDelete(row.id)}
        />
      ),
    },
  ]);

  const filtersConfig = [
    { name: "serialNo", label: "Serial No.", type: "text", width: "18%" },
    { name: "company", label: "Company", type: "text", width: "18%" },
    {
      name: "reviewType",
      label: "Review Type",
      type: "select",
      width: "18%",
      options: [
        { value: "Incoming", label: "Incoming" },
        { value: "Outgoing", label: "Outgoing" },
        { value: "In Process", label: "In Process" },
      ],
    },
    { name: "reviewer", label: "Reviewer", type: "text", width: "18%" },
    {
      name: "status",
      label: "Status",
      type: "select",
      width: "18%",
      options: [
        { value: "Draft", label: "Draft" },
        { value: "Submitted", label: "Submitted" },
        { value: "Cancelled", label: "Cancelled" },
      ],
    },
  ];

  const filteredRows = useMemo(() => {
    const hasFilters = Object.values(filters).some(Boolean);
    if (!hasFilters) {
      return qualityReviews;
    }

    return qualityReviews.filter((row) =>
      Object.entries(filters).every(([key, value]) => {
        if (!value) return true;
        const fieldValue = row[key];
        if (typeof fieldValue === "string") {
          return fieldValue.toLowerCase().includes(String(value).toLowerCase());
        }
        return fieldValue === value;
      })
    );
  }, [filters, qualityReviews]);

  const tableData = useMemo(() => {
    const page_length = 10; // force 10 rows per page
    const start = (currentPage - 1) * page_length;
    const end = start + page_length;

    return filteredRows.slice(start, end).map((row, index) => ({
      ...row,
      siNo: index + 1 + start,
    }));
  }, [filteredRows, currentPage]);

  const toggleRowSelection = (rowIndex) => {
    setSelectedRows((prev) => {
      if (prev.includes(rowIndex)) {
        return prev.filter((idx) => idx !== rowIndex);
      } else {
        return [...prev, rowIndex];
      }
    });
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      const currentPageIndices = tableData.map(
        (_, index) => (currentPage - 1) * 10 + index
      );
      setSelectedRows(currentPageIndices);
    }
    setSelectAll(!selectAll);
  };

  // Update selectAll when selectedRows change
  useMemo(() => {
    const currentPageIndices = tableData.map(
      (_, index) => (currentPage - 1) * 10 + index
    );
    const allSelected = currentPageIndices.every((index) =>
      selectedRows.includes(index)
    );
    setSelectAll(allSelected && currentPageIndices.length > 0);
  }, [selectedRows, tableData, currentPage]);

  const handleView = (id) => {
    navigate("/master/quality-review/view-quality-review", {
      state: { reviewId: id },
    });
  };

  const handleEdit = (id) => {
    navigate("/master/quality-review/edit-quality-review", {
      state: { reviewId: id },
    });
  };

  const handleDelete = (id) => {
    console.log("Delete Quality Review", id);
  };

  const handleSaveColumns = (selectedKeys) => {
    setColumnsConfig((prev) =>
      prev.map((column) => ({
        ...column,
        visible: selectedKeys.includes(column.accessor),
      }))
    );
  };

  const visibleColumns = useMemo(
    () => columnsConfig.filter((col) => col.visible),
    [columnsConfig]
  );
  const defaultSelectedColumns = useMemo(
    () =>
      columnsConfig
        .filter((col) => col.visible)
        .map((col) => ({
          fieldname: col.accessor,
          label: col.name,
        })),
    [columnsConfig]
  );

  const exportFields = useMemo(
    () =>
      columnsConfig
        .filter(
          (column) =>
            column.accessor &&
            column.accessor !== "action" &&
            column.accessor !== "siNo"
        )
        .map((column) => column.accessor),
    [columnsConfig]
  );

  const activeFilterCount = useMemo(
    () =>
      Object.values(filters).filter(
        (value) => value !== undefined && value !== ""
      ).length,
    [filters]
  );

  const actionButtons = [
    {
      className: "createbtnsfilter border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children:
        activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters((prev) => !prev);
        setShowColumns(false);
      },
    },
    {
      className: "btnsecond border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show Columns",
      onClick: () => {
        setShowColumns((prev) => !prev);
        setShowFilters(false);
      },
    },
    {
      className: "btnthird border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExport(true),
    },
    {
      className: "custom-btn-00989 d-flex",
      to: "/master/quality-review/create-quality-review",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add Quality Review",
    },
  ];

  const handleFilterChange = (newFilters) => {
    setCurrentPage(1);
    setFilters(newFilters);
  };

  // Reset select all when page changes
  useMemo(() => {
    setSelectAll(false);
    setSelectedRows([]);
  }, [currentPage]);

  return (
    <div className="container-fluid d-flex flex-column" style={{ flexGrow: 1 }}>
      <Tabs />
      <ListLayout
        breadcrumbItems={[
          { label: "Quality Review" },
          { label: "Quality Review List", style: { color: "#4b002b" } },
        ]}
        actionButtons={actionButtons}
      >
        {showFilters && (
          <ListFilters
            filtersConfig={filtersConfig}
            onFilterChange={handleFilterChange}
            currentFilters={filters}
            setShowFilters={setShowFilters}
          />
        )}

        {showColumns && (
          <ConfigureColumnsNew
            show={showColumns}
            onClose={() => setShowColumns(false)}
            onSave={handleSaveColumns}
            docType="Quality Review"
            defaultSelected={defaultSelectedColumns}
            fieldsData={columnsConfig.map((col) => ({
              fieldname: col.accessor,
              label: col.name,
            }))}
            disabledFields={["siNo", "action"]}
          />
        )}

        <Table columns={visibleColumns} data={tableData} loading={false} />

        <Pagination
          setCurrentPage={setCurrentPage}
          pageSize={10}
          totalRecords={filteredRows.length}
          currentPage={currentPage}
          className="mt-2 pb-3"
        />

        {showExport && (
          <ExportCSV
            doctype="Quality Review"
            fieldsData={exportFields}
            onClose={() => setShowExport(false)}
          />
        )}
      </ListLayout>

  
    </div>
  );
};

export default MainList;
